import React, { useState, useEffect } from 'react';
//, Fragment
import { Alert, Row, Col } from 'react-bootstrap';
//import { useNavigate, useParams } from 'react-router-dom';
//import axios from 'axios';
//import { apiUrl } from '../../../util/Api';
import ExperimentComparison from './ExperimentComparison';
import {Bar} from 'react-chartjs-2';
//, Pie
import { Chart as ChartJS, ArcElement,  Tooltip, Legend } from 'chart.js';
//PointElement, LinearScale, BarElement, CategoryScale, Title,
import {  getColors, roundNum, getColor, getColorForOriginal } from '../../../util/ChartUtils';
ChartJS.register(ArcElement, Tooltip, Legend);


const ExperimentReport = (props) => {

    const experiments = props?.experiments ? props.experiments : [];
    const accountKey = props?.accountKey ? props.accountKey : '';
    const original = props?.original ? props.original : null;
    const [errors, setErrors] = useState([]);

    //send experiments to python processor to get similarities between the responses
    
    useEffect(() => {
        //console.log(experiments)
        /*
        axios.get(apiUrl + '/genai-providers', { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    let providers = res.data.providers;

                    //TODO: need to filter list of providers to ones not already selected
                    //setProviders(providers.filter(provider => provider.providerId >0 && provider.providerId < 3));
                    //console.log('getting providers')
                    //setProviders(providers)
                    let existing = new Set(providerKeys.map(p => p.providerId))
                    let filtered = providers.filter(p => !existing.has(p.providerId))
                    setProviders(filtered)
                    if (filtered.length > 0) {
                        //hide button!
                        setShowAddBtn(true)
                    } else {
                        setShowAddBtn(false)
                    }
                    //filterProviders(providers, providerKeys)
                }
            })
            .catch((err) => {

            });
            */
    }, [accountKey, experiments]);
    

    return (
        <div>
            <h4 className='mt-3'>Results</h4>

            {
                (errors.length > 0) ? (
                    <Alert variant='danger'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {
                (experiments.length > 0) ? (
                    <>
                    <Row className='mt-3'>
                        <>
                        {original !== null ? (
                        <Col >
                        <div className='chart-card'>
                            <div className='chart-title'>original</div>
                            <ResponseBubbles responses={[{content: (original?.responses ? original?.responses[0]?.response : "")}]}/>
                            <div >Prompt Tokens: {original.promptTokens}</div>
                            <div >Completion Tokens: {original.completionTokens}</div>
                            <div >Latency: {original.latency}</div>
                            <div >Cost: {roundNum(original.totalCost,6)}</div>
                        </div>
                        </Col>
                    ) : null}
                        {experiments.map((experiment, i) => (
                            <Col key={`experiment.${i}`}>
                                <div className='chart-card'>
                                    <div className='chart-title'>{experiment.provider}: {experiment.model}</div>
                                    <ErrorResult error={experiment?.results?.error}/>
                                    <ResponseBubbles responses={experiment?.results?.responses}/>
                                    <div >Prompt Tokens: {experiment?.results?.promptTokens}</div>
                                    <div >Completion Tokens: {experiment?.results?.completionTokens}</div>
                                    <div >Latency: {experiment?.results?.latency}</div>
                                    <div >Cost: {roundNum(experiment?.results?.cost,6)}</div>
                                    {/*<div>Similarity: (chart comparing each to each other)</div>*/}
                                </div>
                            </Col>
                        ))}
                        </>
                    </Row>
                    <Row className='my-4'>
                            <Col>
                                <div className='chart-card'>
                                    <div className='chart-title'>Costs</div>
                                    <CostsBarChart experiments={experiments} original={original}/>
                                    </div>
                            </Col>
                            <Col>
                            <div className='chart-card'>
                                    <div className='chart-title'>Latency</div>
                                    <LatencyBarChart experiments={experiments} original={original}/>
                                    </div>
                            </Col>
                    </Row>

                    <Row className='my-4'>
                            <Col>
                                <div className='chart-card'>
                                    <div className='chart-title'>Prompt Tokens</div>
                                    <TokensInBarChart experiments={experiments} original={original}/>
                                    </div>
                            </Col>
                            <Col>
                            <div className='chart-card'>
                                    <div className='chart-title'>Completion Tokens</div>
                                    <TokensOutBarChart experiments={experiments} original={original}/>
                                    </div>
                            </Col>
                    </Row>
                    <Row className='my-4'>
                        <ExperimentComparison accountKey={accountKey} experiments={experiments} original={original}/>
                    </Row>
                    </>
                ) : (null)
            }
        </div>
    )
}

const ErrorResult = (props) => {
    let error = props.error;
    if(error == null || error == "") {
        return null
    }

    return (
        <Alert variant='danger'>{error}</Alert>
    )
}

const ResponseBubbles = (props) => {
    let responses = props.responses;
    if(responses == null || responses.length < 1) {
        return null
    }

    return (
        <>
        {responses.map((response, r) => (
            <div className='chat-bubble my-2' key={`response.${r}`}>{response.content}</div>
        ))}
        </>
        
    )
}
const CostsBarChart = (props) => {
    let original = props?.original ? props.original : null;
    let experiments = props.experiments; 
    let data = experiments.map((e,n) => { return { model: e.model, cost: e?.results?.cost, color: getColor(n) } })
    
    if(data == null || data.length < 1){
        return null;
    }

    //if original present, add it to the data array
    if(original !== null){
        data.push({model: 'original', cost: original?.totalCost, color: getColorForOriginal()})
    }

    data.sort((a, b) => (a.cost < b.cost) ? 1 : -1)
    let labels = data.map((elem, e) => (
        elem.model
    ))
    let metrics = data.map((elem, e) => (
        elem?.cost ? elem.cost : 0
    ))
    //let colors = getColors(data.length);
    let colors = data.map((elem, e) => (elem.color))

    let total = metrics.reduce((temp, x) => temp + x, 0);
    return (
        <div className='chart-card'>
            <div className='chart-title'>${roundNum(total, 6)} Total Cost</div>
            <Bar data={
                {
                    labels: labels,
                    datasets: [
                        {
                            label: 'cost',
                            data: metrics,
                            backgroundColor: colors,
                        }
                    ]
                }
            }
            options={{
                indexAxis: 'y',
                elements: {
                    bar: {
                    borderWidth: 2,
                    },
                },
                responsive: true,
                scales: { 
                    y: { 
                        suggestedMin: 0 ,
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                        
                    }, 
                    x: {
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                    }
                },
                plugins: {
                    legend : {
                        display: false,
                        labels : {usePointStyle : true, boxHeight: 8}, 
                        position: 'right',
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,6)
                            }
                        }
                    }
                }
            }} />
        </div>
    )

}

const LatencyBarChart = (props) => {
    let original = props?.original ? props.original : null;
    let experiments = props.experiments; 
    let data = experiments.map((e,n) => { return { model: e.model, latency: e?.results?.latency, color: getColor(n) } })

    if(data == null || data.length < 1){
        return null;
    }

    //if original present, add it to the data array
    if(original !== null){
        data.push({model: 'original', latency: original?.latency, color: getColorForOriginal()})
    }

    data.sort((a, b) => (a.latency < b.latency) ? 1 : -1)
    let labels = data.map((elem, e) => (
        elem.model
    ))
    let metrics = data.map((elem, e) => (
        elem?.latency ? elem.latency : 0
    ))
    //let colors = getColors(data.length);
    let colors = data.map((elem, e) => (elem.color))

    //let totalLatency = metrics.reduce((temp, x) => temp + x.latency, 0);
    //let totalInteractions = metrics.reduce((temp, x) => temp + x.interactions, 0);
    let totalLatency = 0;
    let totalInteractions = data.length;
    data.forEach((item, i) => {
        totalLatency += item?.latency ? item.latency : 0;
    })
    let avg = totalInteractions > 0 ? (totalLatency/totalInteractions) : 0;
    //let total = metrics.reduce((temp, x) => temp + x, 0);

    return (
        <div className='chart-card'>
            <div className='chart-title'>{roundNum(avg,0)} Average Latency</div>
            <Bar data={
                {
                    labels: labels,
                    datasets: [
                        {
                            label: 'ms',
                            data: metrics,
                            backgroundColor: colors,
                        }
                    ]
                }
            }
            options={{
                indexAxis: 'y',
                elements: {
                    bar: {
                    borderWidth: 2,
                    },
                },
                responsive: true,
                scales: { 
                    y: { 
                        suggestedMin: 0 ,
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                        
                    }, 
                    x: {
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                    }
                },
                plugins: {
                    legend : {
                        display: false,
                        labels : {usePointStyle : true, boxHeight: 8}, 
                        position: 'right',
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,0)
                            }
                        }
                    }
                }
            }} />
        </div>
    )

}
const TokensInBarChart = (props) => {
    let original = props?.original ? props.original : null;
    let experiments = props.experiments; 
    let data = experiments.map((e,n) => { return { model: e.model, tokens: e?.results?.promptTokens, color: getColor(n) } })
    
    if(data == null || data.length < 1){
        return null;
    }

    if(original !== null){
        data.push({model: 'original', tokens: original?.promptTokens, color: getColorForOriginal()})
    }

    data.sort((a, b) => (a.tokens < b.tokens) ? 1 : -1)
    let labels = data.map((elem, e) => (
        elem.model
    ))
    let metrics = data.map((elem, e) => (
        elem?.tokens ? elem.tokens : 0
    ))
    //let colors = getColors(data.length);
    let colors = data.map((elem, e) => (elem.color))

    let total = metrics.reduce((temp, x) => temp + x, 0);

    let totalTokens = 0;
    let totalInteractions = 0;
    data.forEach((item, i) => {
        if(item.tokens != null){
            totalTokens += item.tokens;
            totalInteractions++;
        }
    })
    let avg = totalInteractions > 0 ? (totalTokens/totalInteractions) : 0;

    return (
        <div className='chart-card'>
            <div className='chart-title'>{roundNum(avg, 0)} Average Tokens</div>
            <Bar data={
                {
                    labels: labels,
                    datasets: [
                        {
                            label: 'tokens',
                            data: metrics,
                            backgroundColor: colors,
                        }
                    ]
                }
            }
            options={{
                indexAxis: 'y',
                elements: {
                    bar: {
                    borderWidth: 2,
                    },
                },
                responsive: true,
                scales: { 
                    y: { 
                        suggestedMin: 0 ,
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                        
                    }, 
                    x: {
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                    }
                },
                plugins: {
                    legend : {
                        display: false,
                        labels : {usePointStyle : true, boxHeight: 8}, 
                        position: 'right',
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,0)
                            }
                        }
                    }
                }
            }} />
        </div>
    )

}
const TokensOutBarChart = (props) => {
    let original = props?.original ? props.original : null;
    let experiments = props.experiments; 
    let data = experiments.map((e,n) => { return { model: e.model, tokens: e?.results?.completionTokens, color: getColor(n) } })
    
    if(data == null || data.length < 1){
        return null;
    }
    if(original !== null){
        data.push({model: 'original', tokens: original?.completionTokens, color: getColorForOriginal()})
    }
    data.sort((a, b) => (a.tokens < b.tokens) ? 1 : -1)
    let labels = data.map((elem, e) => (
        elem.model
    ))
    let metrics = data.map((elem, e) => (
        elem?.tokens ? elem.tokens : 0
    ))
    //let colors = getColors(data.length);
    let colors = data.map((elem, e) => (elem.color))

    let total = metrics.reduce((temp, x) => temp + x, 0);

    let totalTokens = 0;
    let totalInteractions = 0;
    data.forEach((item, i) => {
        if(item.tokens != null){
            totalTokens += item.tokens;
            totalInteractions++;
        }
    })
    let avg = totalInteractions > 0 ? (totalTokens/totalInteractions) : 0;

    return (
        <div className='chart-card'>
            <div className='chart-title'>{roundNum(avg, 0)} Average Tokens</div>
            <Bar data={
                {
                    labels: labels,
                    datasets: [
                        {
                            label: 'tokens',
                            data: metrics,
                            backgroundColor: colors,
                        }
                    ]
                }
            }
            options={{
                indexAxis: 'y',
                elements: {
                    bar: {
                    borderWidth: 2,
                    },
                },
                responsive: true,
                scales: { 
                    y: { 
                        suggestedMin: 0 ,
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                        
                    }, 
                    x: {
                        border:{dash: [3, 3], color:'#dedede'},
                        grid: {
                            color: '#e3e3e3',
                        }
                    }
                },
                plugins: {
                    legend : {
                        display: false,
                        labels : {usePointStyle : true, boxHeight: 8}, 
                        position: 'right',
                    },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                return ctx.dataset.label + ': ' + roundNum(ctx.parsed.x,0)
                            }
                        }
                    }
                }
            }} />
        </div>
    )

}
export default ExperimentReport;